/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_Edit_BtnInputs */

const vi_pl_pnk_edit_btn = /** @type {(inputs: Pl_Pnk_Edit_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa`)
};

/**

* @param {Pl_Pnk_Edit_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_edit_btn = /** @type {((inputs?: Pl_Pnk_Edit_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_Edit_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_edit_btn(inputs)
});